/** Mirrors platform shared/utils/files.ts bytesToHumanReadable for attachment labels. */
export function formatAttachmentSize(bytes: number): string {
  const out = (`${'0'.repeat((bytes.toString().length * 2) % 3)}${bytes}`).match(/.{3}/g);

  if (!out || bytes < 1000) {
    return `${bytes} Bytes`;
  }

  const fractional = out[1].substring(0, 2);

  return `${Number(out[0])}${fractional === '00' ? '' : `.${fractional}`} ${'  kMGTPEZY'[out.length]}B`;
}

export function extensionFromTitle(title: string): string | undefined {
  const parts = title.split('.');

  return parts.length > 1 ? parts.pop()?.slice(0, 4) : undefined;
}
